import { GET } from "./";
export const home = {
  getProject: () => GET(`/api/home/projectsHome`),
  getNew: (newId) => GET(`/api/home/newsletter/${newId}`),
  getSave: (email) => GET(`/api/home/suscription/${email}`),
};
